import { Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { ConfirmDialog } from "components/ConfirmDialog";
import { ReactNode } from "react";

// Snap grid height to the row count: ~56px header + ~38px/row, with a floor of
// two rows for the empty state and a cap so long lists still scroll.
export function roleGridHeight(rowCount: number): number {
  return Math.min(520, 64 + Math.max(rowCount, 2) * 38);
}

// Permissions are stored as an array; both grids surface only the count.
export function permissionsCountColumn<T extends { permissions?: unknown[] | null }>(
  overrides?: Partial<GridColDef<T>>
): GridColDef<T> {
  return {
    field: "permissions",
    headerName: "Permissions",
    type: "number",
    sortable: false,
    valueGetter: (_value, row) => row.permissions?.length ?? 0,
    ...overrides,
  };
}

type DeleteRoleConfirmDialogProps = {
  open: boolean;
  header: string;
  info: ReactNode;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function DeleteRoleConfirmDialog({
  open,
  header,
  info,
  loading,
  onClose,
  onConfirm,
}: DeleteRoleConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      header={header}
      // Pin to the 440px confirmation-dialog spec (shared default stretches to 640).
      maxWidth="440px"
      confirmText="Yes, delete it"
      cancelText="Cancel"
      onConfirm={onConfirm}
      info={
        <Typography variant="body2" component="span">
          {info}
        </Typography>
      }
      loading={loading}
      disableConfirm={!open}
    />
  );
}
